import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import reducer from "./Reducers/index";

// Persisted the store configuration
const persistConfig = {
  key: "root",
  storage,
};

// Persist the reducer
const persistedReducer = persistReducer(persistConfig, reducer);

// Create the store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: process.env.NODE_ENV !== "production",
});

// Persist the store
const persistedStored = persistStore(store);

export { persistedStored, store };
